// Module
var code = "<md-button class=\"md-primary md-raised md-button\" ng-class=\"{ 'has-sibling' : $ctrl.hasSibling, 'hidden' : $ctrl.isHidden }\" ng-href=\"{{ $ctrl.config.supportIEUrl }}\" target=\"_blank\"><span translate>besoin_d_aide</span></md-button> ";
// Exports
module.exports = code;